import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getBuildablePlanSummaryCards } from 'constants/routes';

/**
 * Retrieves buildable plans summary information from a given community id.
 * @param {Object} communityId - community identifier to query.
 * @param {Object} marketId - market identifier to query.
 * @returns {Observable} - An observable that emits the plan summary information.
 */
const getBuildablePlanSummaryCardsInformation = (communityId, marketId) => {
  const params = new URLSearchParams();
  params.append('communityId', communityId);

  if (marketId) {
    params.append('marketId', marketId);
  }

  const url = `${getBuildablePlanSummaryCards}?${params.toString()}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json())
  );
};

export default getBuildablePlanSummaryCardsInformation;